import type { V2Proof } from './content';

export function Proof({ content }: { content: V2Proof }) {
  return (
    <section className="v2-section v2-proof">
      <div className="v2-container">
        <div className="v2-section-head">
          <span className="v2-eyebrow" data-reveal>
            {content.eyebrow}
          </span>
          <h2 className="v2-h2" data-reveal data-reveal-delay="0.08">
            {content.title}
          </h2>
        </div>

        <div className="v2-proof-grid" data-reveal-group>
          {content.stats.map((stat, index) => (
            <article className={`v2-proof-card ${index === 0 ? 'v2-proof-lead' : ''}`} key={stat.label}>
              <span className="v2-proof-label">{stat.label}</span>
              <h3>{stat.title}</h3>
              <p>{stat.body}</p>
            </article>
          ))}
        </div>

        <p className="v2-proof-source" data-reveal>
          {content.source}
        </p>
      </div>
    </section>
  );
}
